import type { ExpenseLine } from './model';

/** Booking expense line payload for create/update mutations. */
export type BookingExpenseLineInput = ExpenseLine;

/** Client-side id before the expense row is persisted (v1 `temp-*` convention). */
export function isClientOnlyExpenseLineId(id: string): boolean {
  if (!id) {
    return true;
  }
  if (id.includes('temp-')) {
    return true;
  }
  const numericId = Number(id);
  return !Number.isFinite(numericId);
}

export function isMeaningfulBookingExpenseLine(
  line: BookingExpenseLineInput
): boolean {
  if (!isClientOnlyExpenseLineId(line.id)) {
    return true;
  }
  const hasAmount = line.charge.amountPerUnit !== 0;
  const hasVendor = Boolean(line.vendor?.trim());
  return hasAmount || hasVendor;
}

export function filterMeaningfulBookingExpenseLines(
  lines: BookingExpenseLineInput[]
): BookingExpenseLineInput[] {
  return lines.filter(isMeaningfulBookingExpenseLine);
}

export function expenseLineFromBookingExpenseInput(
  line: BookingExpenseLineInput
): ExpenseLine {
  return line;
}
